<header>
	<div class="container-sm">
		<div class="header-top">
			<!-- logo and menu -->
			<div class="logo_area">
				<!-- menu -->
				<ng-container *ngIf='appService.domain && appService.Categories.length > 0'>
					<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<i class="bi bi-list"></i>
					</button>
				</ng-container>
				<!-- logo -->
				<ng-container *ngIf='appService.Logo'>
					<!-- [routerLink]="['/d', appService.domainId, 'list']" -->
					<a class="navbar-brand" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
						<img [src]="appService.getBaseServerAddress() + '/document_files/download/' + appService.Logo" class="logo" />
					</a>
				</ng-container>
			</div>
			<!-- right part -->
			<div class="dropdown pull-right cart_lang">
				<div class="mobile_cart">
					<a [routerLink]='["/d", appService.domainId, "cart"]' class="cart dropdown-toggle" data-toggle="dropdown" [attr.disabled]='cartService.loading.value'>
						<i class="fa fa-shopping-cart"></i> <span class="cart_txt">{{'Carrello' | translate}}</span> <span class="badge" *ngIf='!cartService.loading.value && cartData && cartData.num_items'>{{cartData.num_items}}</span>
						<span class='fa fa-spinner fa-spin' style="position: relative; left: 10px;" *ngIf='cartService.loading.value'></span>
					</a>
				</div>

				<div class="desktop_cart">
					<!-- cart dropdown -->
					<a class="cart dropdown-toggle" data-toggle="dropdown" [attr.disabled]='cartService.loading.value'>
						<i class="fa fa-shopping-cart"></i> <span class="cart_txt">{{'Carrello' | translate}}</span> <span class="badge" *ngIf='!cartService.loading.value && cartData && cartData.num_items'>{{cartData.num_items}}</span>
						<span class='fa fa-spinner fa-spin' style="position: relative; left: 10px;" *ngIf='cartService.loading.value'></span>
					</a>
		
					<!-- cart dropdown content -->
					<div class="dropdown-menu cart-dropdown-menu">
						<div [ngClass]="{'shopping-cart': true, 'hidden': cartService.loading.value}" *ngIf='!cartService.loading.value'>
							<span class="clear-cart" (click)='cartService.clearCart()' *ngIf='cartData && cartData.num_items > 1'>{{'Svuota carrello' | translate}}</span>
						
							<div [ngClass]='{"shopping-cart-header": true, "without-badge": cartData && !cartData.num_items}'>
								<div class="icons">
									<i class="fa fa-shopping-cart cart-icon"></i>
									<span class="badge" *ngIf='cartData && cartData.num_items'>{{cartData.num_items}}</span>
								</div>
								<div class="shopping-cart-total">
									<span class="lighter-text">{{'Totale' | translate}}:&nbsp;</span>
									<span [ngClass]="{'main-color-text': true, 'hidden': cartData.subtotal_cart === cartData.total_cart, 'line-through': cartData.subtotal_cart > cartData.total_cart}">
										{{cartData.subtotal_cart | currency:'EUR'}}
									</span>
									<span class="main-color-text">{{cartData.total_cart | currency:'EUR'}}</span>
								</div>
							</div> <!--end shopping-cart-header -->
						
							<ul class="shopping-cart-items">
								<ng-container *ngFor='let key of cartData.cart_items | customKeys'>
									<ng-container [ngSwitch]='cartData.cart_items[key].target'>
										<!-- TRIP_PACKAGE -->
										<ng-container 
											*ngSwitchCase='"trip_packages"'
											[ngTemplateOutlet]='trip_packages_cart'
											[ngTemplateOutletContext]='{ cartItem: cartData.cart_items[key] }'
										></ng-container>
										<!-- PRODUCT -->
										<ng-container 
											*ngSwitchCase='"product"'
											[ngTemplateOutlet]='products_cart'
											[ngTemplateOutletContext]='{ cartItem: cartData.cart_items[key] }'
										></ng-container>
										<!-- NO TARGET -->
										<div *ngSwitchDefault>Nessun template configurato per il target di riferimento</div>
									</ng-container>
								</ng-container>
							</ul>
						
							<div class="row" *ngIf='cartData.can_checkout'>
								<div class="col-6" style="padding-right: 5px;">
									<a [routerLink]="['/d', appService.domainId, 'cart']" class="button">{{'Carrello' | translate}}</a>
								</div>
								<div class="col-6" style="padding-left: 5px;">
									<a [routerLink]="['/d', appService.domainId, 'checkout']" class="button">{{'Checkout' | translate}}</a>
								</div>
							</div>
							<div class="cart-loading" *ngIf='cartService.loading.value'>
								<span class='fa fa-spinner fa-spin'></span>
							</div>
						</div> <!--end shopping-cart -->
					</div>
				</div>

				<!-- language switcher -->
				<language-switcher></language-switcher>
				<!-- language switcher -->
			</div><!-- end navbar-right -->
		</div>
	</div>

	<nav class="navbar navbar-expand-lg navbar-light" *ngIf='appService.domain && appService.Categories.length > 0'>
		<div class="container-sm">	
			<div class="collapse navbar-collapse" id="navbarNav">
				<ul class="navbar-nav">
					<!-- le prime 5 categorie -->
					<li *ngFor='let category of appService.Categories | slice:0:5'>
						<a [routerLink]="['/d', appService.domainId, 'category', category.id]">
							{{category.description}}
						</a>
					</li>
					<li class="mobile" *ngFor='let category of appService.Categories | slice:5'>
						<a [routerLink]="['/d', appService.domainId, 'category', category.id]">
							{{category.description}}
						</a>
					</li>
					<!-- MENU A DISCESA PER IL RESTO DELLE CATEGORIE -->
					<ng-container *ngIf='appService.Categories.length > 5'>
						<li class="dropdown categories desktop" *ngIf='appService.Categories'>
							<a class="dropdown-toggle dropdown-category-item" data-toggle="dropdown">
								{{'Categorie' | translate}} <i class="fa fa-caret-down"></i>
							</a>
							<ul class="dropdown-menu">
								<ng-container *ngFor='let category of appService.Categories | slice:5'>
									<li>
										<a [routerLink]="['/d', appService.domainId, 'category', category.id]">
											{{category.description}}
										</a>
									</li>
								</ng-container>
							</ul>
						</li>
					</ng-container>
					<!-- MENU A DISCESA -->
				</ul>
			</div>
		</div> <!-- end container -->
	</nav>
</header>

<!-- TRIP_PACKAGES CART -->
<ng-template #trip_packages_cart let-cartItem='cartItem'>
	<li class="clearfix">
		<div *ngIf='cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(' + appService.getBaseServerAddress() + '/document_files/resize/140x70/' + cartItem.target_info.master_image_item + ')'}" class="master_image"></div>
		<div *ngIf='!cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(assets/img/140x70.png)'}" class="master_image"></div>
		<span class="item-name">{{cartItem.target_info.variation_name_item}}</span>
		<span class="remove-item" (click)='cartService.removeItem(cartItem.id)'><i class="fa fa-times"></i></span>
	</li>

	<div class="price-item">
		<span class="item-price">{{cartItem.trip_booking.total_amount | currency:'EUR'}}</span>
	</div>

	<div class="participants">
		<span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
			ADT: {{ cartItem.trip_booking.participant_counters["ADT"] }}
		</span>
		<span class="chd" *ngIf='cartItem.trip_booking.participant_counters["CHD"]'>
			CHD: {{ cartItem.trip_booking.participant_counters["CHD"] }}
		</span>
		<span class="inf" *ngIf='cartItem.trip_booking.participant_counters["INF"]'>
			INF: {{ cartItem.trip_booking.participant_counters["INF"] }}
		</span>
		<span class="snr" *ngIf='cartItem.trip_booking.participant_counters["SNR"]'>
			SNR: {{ cartItem.trip_booking.participant_counters["SNR"] }}
		</span>
	</div>
</ng-template>
<!-- PRODUCTS CART -->
<ng-template #products_cart let-cartItem='cartItem'>
	<li class="clearfix">
		<div *ngIf='cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(' + appService.getBaseServerAddress() + '/document_files/resize/140x70/' + cartItem.target_info.master_image_item + ')'}" class="master_image"></div>
		<div *ngIf='!cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(assets/img/140x70.png)'}" class="master_image"></div>
		<span class="item-name">{{cartItem.target_info.display_name_item}}</span>
		<span class="remove-item" (click)='cartService.removeItem(cartItem.id)'><i class="fa fa-times"></i></span>
	</li>

	<div class="price-item">
		<span class="item-price">{{cartItem.trip_booking.total_amount | currency:'EUR'}}</span>
	</div>

	<div class="participants">
		<span class="adt" *ngIf='cartItem.trip_booking.participant_count'>
			{{'Quantità' | translate}}: {{ cartItem.trip_booking.participant_count }}
		</span>
	</div>
</ng-template>